import { useCallback } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { getOpenDockWarehouseAvailability } from '../../use-cases/getOpenDockWarehouseAvailability'

export function useGetOpenDockWarehouseAvailability() {
  const { call, result, status, error } = useAsync(getOpenDockWarehouseAvailability)
  const abortController = useAbortController()

  const fetchOpenDockWarehouseAvailability = useCallback(
    (
      shipmentUUID: string,
      stopIndex: number,
      {
        loadTypeId,
        dockId,
        appointmentDate,
        facilityTimezone,
      }: { loadTypeId: string; dockId: string; appointmentDate: string; facilityTimezone?: string }
    ) => {
      return call({
        shipmentUUID,
        stopIndex,
        params: { loadTypeId, dockId, appointmentDate, facilityTimezone },
        config: abortController,
      })
    },
    [abortController, call]
  )

  return {
    warehouseAvailability: result,
    status,
    error,
    fetchOpenDockWarehouseAvailability,
  }
}
